import Home from "./Components/home/Home";
import ProjectList from "./Components/projectList/ProjectList";
import About from "./Components/Pages/About";
import Contact from "./Components/contact/Contact";
import LoadingPage from "./Components/Pages/LoadingPage";
import DisableInspect from "./Components/Security/DisableInspect";
// import Practice from "./Components/Practice";
// import Chatbot from "./Components/Pages/Chatbot.js";
// import StarCanvas from "./Components/Pages/StarCanvas.js";
import { useState, useEffect, useContext } from "react";
import { ThemeContext } from "./context.js";
import Navbar from "./Components/navbar/Navbar";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <div
      className="App"
      style={{
        backgroundColor: darkMode ? "#111" : "white",
        color: darkMode && "white",
      }}
    >
      <DisableInspect />
      {loading ? (
        <LoadingPage />
      ) : (
        <BrowserRouter>
          <Navbar />
          {/* <Home />
      <About />
      <ProjectList />
      <Contact />   */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/project" element={<ProjectList />} />
            <Route path="/contact" element={<Contact />} />
            {/* <Route path="/stars" element={<StarCanvas />} /> */}
            {/* <Route path="/practice" element={<Practice />} /> */}
            {/* <Route path="/chatbot" element={<Chatbot />} /> */}

            <Route path="*" element={<h1>Error 404 Page not found!!</h1>} />
          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
